import { ref } from '@vue/composition-api'

import useForm from '@/compositions/useForm'
import useRequest from '@/compositions/useRequest'

import { required } from '@/utils/validations'

import Document from '@/components/Document/Document'

export default {
  props: {
    orderId: Number,
  },
  components: { Document },

  setup(props, context) {
    const dialog = ref(false)
    const readonly = ref(true)
    const { emit } = context

    const { $store } = context.root

    const { makeRequest, loading } = useRequest({
      context,
      request: data => $store.dispatch('orders/createDocument', { orderId: props.orderId, data }),
    })

    const {
      validate, $errors, formData, getData,
    } = useForm({
      fields: {
        name: { default: '', validations: { required } },
        documentType: { default: '' },
        file: { default: undefined, validations: { required } },
      },
    })

    const submit = async () => {
      if (!validate()) return

      await makeRequest(getData())
      dialog.value = false
      emit('add')
    }

    const comboItems = [
      'Акт выполненных работ',
      'Счет на оплату',
      'Счет-фактура',
      'Путевой лист',
      'Договор',
      'Проект',
      'Исполнительная документация',
      'Приказ',
      'Предписание',
      'Сообщение',
    ]

    return {
      dialog,
      submit,
      $errors,
      loading,
      formData,
      comboItems,
      console,
      readonly,
    }
  },
}
